import { motion } from 'framer-motion';
import { Fingerprint, LayoutDashboard, MapPin, Radio } from 'lucide-react';
import { Section, SectionTitle } from '@/components/landing/Section';

const FEATURES = [
  {
    icon: LayoutDashboard,
    title: 'Gestión operativa',
    text: 'Plataforma centralizada para administrar guardias, turnos y novedades en tiempo real.',
  },
  {
    icon: Fingerprint,
    title: 'Control biométrico',
    text: 'Registro de asistencia y accesos con verificación biométrica confiable.',
  },
  {
    icon: Radio,
    title: 'Comunicación',
    text: 'Coordinación inmediata entre puestos, supervisores y central de monitoreo.',
  },
  {
    icon: MapPin,
    title: 'Rastreo',
    text: 'Geolocalización de rondas y móviles para garantizar la cobertura efectiva.',
  },
];

export function About() {
  return (
    <Section id="about" className="border-y">
      <SectionTitle subtitle="Combinamos personal capacitado con herramientas digitales de última generación.">
        Seguridad respaldada por tecnología
      </SectionTitle>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {FEATURES.map((f, i) => {
          const Icon = f.icon;
          return (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              whileHover={{ y: -4 }}
              className="rounded-2xl border border-white/[0.06] bg-white/[0.02] p-6 transition-colors hover:bg-white/[0.04]"
            >
              <Icon className="h-9 w-9 text-primary" strokeWidth={1.5} aria-hidden />
              <h3 className="mt-4 text-lg font-semibold">{f.title}</h3>
              <p className="mt-2 text-sm text-slate-400">{f.text}</p>
            </motion.div>
          );
        })}
      </div>
    </Section>
  );
}
